import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, useTheme, Icon, Text, Loader } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotBoxInfo');
var _ref2 = /*#__PURE__*/React.createElement(Loader, null);
const BoxInfo = _ref => {
  let {
    isChart,
    isTable,
    children,
    onDownload,
    loading
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  const bodyClasses = useMemo(() => classNames(classes.body, {
    [classes.bodyChart]: isChart,
    [classes.bodyTable]: isTable
  }), [classes, isChart, isTable]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    color: theme.colors.utility.textSecondary
  }, isChart ? t('label_report') : t('label_table')), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.action,
    name: "downloadAlt",
    onClick: onDownload
  }))), /*#__PURE__*/React.createElement("div", {
    className: bodyClasses
  }, loading ? _ref2 : children));
};
export default /*#__PURE__*/memo(BoxInfo);